<template>
   <div>
   </div>
</template>

<script>
export default {
  props: {
    name: String,
  },

  mounted() {
    window.close()
    if (window.opener) {
      if (this.name == 'advocacy' && typeof(window.opener.setAdvocacyToken) === "function")
        window.opener.setAdvocacyToken(location)
    }
  }
}
</script>
